// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var BrowserStyle = require("../BrowserStyle.bs.js");

var sectionHeader = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.display(BrowserStyle.flexBox),
      tl: {
        hd: BrowserStyle.alignItems(BrowserStyle.center),
        tl: {
          hd: BrowserStyle.justifyContent(BrowserStyle.spaceBetween),
          tl: /* [] */0
        }
      }
    });

var Styles = {
  sectionHeader: sectionHeader
};

function BrowserComponents_DualColumnContent(Props) {
  var className = Props.className;
  var children = Props.children;
  return React.createElement("section", {
              className: BrowserStyle.Utils.extendBaseStyle(sectionHeader, className)
            }, children);
}

var make = BrowserComponents_DualColumnContent;

exports.Styles = Styles;
exports.make = make;
/* sectionHeader Not a pure module */
